// ContactSection.tsx
import React from "react";
import Link from "next/link";
import '@fortawesome/fontawesome-free/css/all.min.css';

const ContactSection: React.FC = () => {
  return (
    <section className="mil-p">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 flex-basis-full">
            <div className="mil-hover-card-all m-4">
              <p className="mil-mb-10 mil-h3">Want to join us?</p>
              <p className="d-flex align-items-center mil-font-2">
                Amazing! Reach out to us
                <Link href="/career#job-openings" className="mil-link ml-2" aria-label="Reach out to us">
                  <i className="fas fa-arrow-right" />
                </Link>
              </p>
            </div>
          </div>
          <div className="col-lg-6 flex-basis-full">
            <div className="mil-hover-card-all m-4">
              <p className="mil-mb-10 mil-h3">Contact us</p>
              <p className="d-flex align-items-center mil-font-2">
                Get in Touch!
                <Link href="/contact-us" className="mil-link" aria-label="Get in Touch">
                  <i className="fas fa-arrow-right" />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
